import firebase_api from '@/firebase/firebase_api'

const object = {
    data: {
        nom: "",
        description: "",
        state: "INPROGRESS",
        id: "",
        pointWin: 2,
        pointLose: 1,
        pointAbs: 0,
        pointEgality: 0,
        pointPres: 0,
        mode: null,
        tolerance: 0,
        joueurs:[],
        tournois:[]
    },
    tournoi: {
        id: "",
        options : {
            nbParties : 3,
            nbJoueurs: null,
            nbJoueursParEquipe: null,
            allEquipePlay: true,
            addPartie: null,
            ifNotFound: {
                win: 13,
                lose: 7
            },
            competition: null,
            mode: null, // ALEATOIRE ou FORME
            joueurs: [],
            GG: false //GAGNANT GAGNANT
        }
    },
    cloture(club, saisonId, classements) {
       
        
        var saisonDb = firebase_api.api.getDb().collection("club").doc(club.id).collection("saisons")
      
        saisonDb.doc(saisonId).update({
            classements: classements,
            state : "FINISH"
        })
    },
    get(club, saisonId, fct) {
        
        var saisonDb = firebase_api.api.getDb().collection("club").doc(club.id).collection("saisons")
        saisonDb.doc(saisonId).get().then(saisonDoc=>{
            fct(saisonDoc.data());
        })
    },
    set(club, saison, fct) {
       
        var saisonDb = firebase_api.api.getDb().collection("club").doc(club.id).collection("saisons")
        var today = new Date();
        saison.date = today.getTime();
        if (saison.id=='') {
            saisonDb.add(saison).then(saisonAdd=>{
                saisonAdd.update({
                    id: saisonAdd.id 
                }).then(()=>{
                    saison.id = saisonAdd.id;
                    fct(saison);
                })
            });
        }
        else {
            saisonDb.doc(saison.id).set(
                saison
            ).then(()=>{
                fct(saison);
            })
        }
    },
    delete (club, saison, fct) {
        var saisonDb = firebase_api.api.getDb().collection("club").doc(club.id)
            .collection("saisons").doc(saison.id).delete().then(()=>{
                fct();
            })
    },
    
    async classement (club, saisonId, fct) {
      
        var saisonDb    = firebase_api.api.getDb().collection("club").doc(club.id).collection("saisons").doc(saisonId);
        var saisonDoc   = await     saisonDb.get();
        var saisonData  = await     saisonDoc.data();
        
        var joueursDb     = firebase_api.api.getDb().collection("club").doc(club.id).collection("joueurs");
        var joueursDoc   = await    joueursDb.get();
        var joueursDocs  = await    joueursDoc.docs;
        var listeDesjoueurs = [];
      
        /*joueursDocs.forEach(joueurClubItem=>{
            console.log(joueurClubItem)
            var joueurData = joueurClubItem.data();
            if (saisonData.joueurs.findIndex(elt=>elt.id === joueurData.id) == -1)
                listeDesjoueurs.push(joueurClubItem.data())
        })*/

        saisonData.joueurs.forEach(joueurSaisonItem=>{
            var joueurDoc = joueursDocs.find(elt=>elt.id === joueurSaisonItem.id)
            if (typeof(joueurDoc)!="undefined") {
                listeDesjoueurs.push(joueurDoc.data())
            }
        })
        
        var tournoisDb     = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
            .where("saison", "==", saisonData.id);
       
        var tournoisDoc   = await    tournoisDb.get();
        var tournoisDocs  = await    tournoisDoc.docs;
        
        var joueursClassements = [];
        // On reparcours la liste de ces joueurs
         // au cas où on aurait un problème avec un joueur oublié
       
        for (var indexTournoiDocItem in tournoisDocs) {
                
            var tournoiDocItem = tournoisDocs[indexTournoiDocItem];
            var tournoiItem = tournoiDocItem.data();
            
            if (tournoiItem.state=="FINISH" && typeof(tournoiItem.classement)!="undefined") {
                var indexJoueurFind = -1;
               
                tournoiItem.joueurs.forEach(joueurTournoi=>{
                    indexJoueurFind = listeDesjoueurs.findIndex(elt=>elt.id === joueurTournoi.id);
                   
                    if (indexJoueurFind==-1) {
                        var joueurDoc = joueursDocs.find(elt=>elt.id === joueurTournoi.id)
                        if (typeof(joueurDoc)!="undefined") {
                            listeDesjoueurs.push(joueurDoc.data())
                        }
                    }
                })
                
            }
        }

        for (var indexJoueurItem in listeDesjoueurs) {
            
            var joueurItem = listeDesjoueurs[indexJoueurItem];
            var tournoisJoueurs = [];
            for (var indexTournoiDocItem in tournoisDocs) {
                
                var tournoiDocItem = tournoisDocs[indexTournoiDocItem];
                var tournoiItem = tournoiDocItem.data();
                


                if (tournoiItem.state=="FINISH" && typeof(tournoiItem.classement)!="undefined") {
                    // on regarde si le joueur a participé au tournoi et on calcule son score
                      
                    var numeroJoueurTournoi = tournoiItem.joueurs.findIndex((elt=>elt.id === joueurItem.id))
                      
                    if (numeroJoueurTournoi!=-1) {
                        if (typeof(tournoiItem.joueurs[numeroJoueurTournoi].meneur)!="undefined") {
                            if (!tournoiItem.joueurs[numeroJoueurTournoi].meneur) {
                                numeroJoueurTournoi = tournoiItem.joueurs.findIndex((elt=>elt.coequipier1 === joueurItem.id))
                                if (numeroJoueurTournoi == -1)
                                    numeroJoueurTournoi = tournoiItem.joueurs.findIndex((elt=>elt.coequipier2 === joueurItem.id))
                            }
                        }
                    }
                    var presentAuConcours = true;
                    if (numeroJoueurTournoi!=-1) {
                        // Ce joueur a participé au tournoi
                        var searchIndex = (element, indice, arraySearch)=>{
                            if (element == null)
                                return false;
                            else 
                                return element.numero == numeroJoueurTournoi;
                        }
                        var indexClassement = tournoiItem.classement.findIndex(searchIndex);
                       
                        var classementItem = tournoiItem.classement[indexClassement];
                        if (typeof(classementItem)=="undefined") {
                            // cela sous entend qu'il a été inscrit mais qu'il a été enlevé au cours la partie
                            // ce joueur n'a donc jamais joué il peut être considéré comme absent
                            presentAuConcours = false;
                        }
                    }
                    else
                        presentAuConcours = false;
                    
                    if (presentAuConcours) {
                            // j'ai mis cette conditions mais c'est à creuser quand même
                           
                            var pointWin = classementItem.nbPartieGagne * saisonData.pointWin;
                            var pointLose = classementItem.nbPartiePerdu * saisonData.pointLose;
                            if (typeof(classementItem.nbPartieEgalite)!="undefined")
                                var pointEgality = classementItem.nbPartieEgalite * saisonData.pointEgality;
                            else
                                var pointEgality = 0;
                            var points = 0;
                            var diff = classementItem.diff;
                      
                            if (typeof(saisonData.pointPres)!="undefined")
                                points += parseInt(saisonData.pointPres);
                            if (saisonData.mode == 0)
                                points += pointWin + pointLose + pointEgality;
                            
                            if (saisonData.mode == 1) {
                                if (typeof(classementItem.classement)=="undefined")
                                    points += indexClassement + 1;
                                else
                                    points += (classementItem.classement);
                            
                            }
                            var rang = indexClassement + 1;
                            if (typeof(classementItem.classement)!="undefined") {
                                rang = classementItem.classement
                            }
                            var tournoiClassement = {
                                rang: rang,
                                date: tournoiItem.date,
                                nbPartieGagne: classementItem.nbPartieGagne,
                                nbPartiePerdu: classementItem.nbPartiePerdu,
                                nbPartieEgalite: classementItem.nbPartieEgalite,
                                present: true,
                                points: points,
                                diff: diff,
                                calcul: false
                            }
                            tournoisJoueurs.push(tournoiClassement);
                    }
                    else {
                        var points = 0;
                        if (saisonData.mode == 0 &&  saisonData.pointAbs!='') {
                            points =  parseInt(saisonData.pointAbs);
                        }
                        if (saisonData.mode == 1 &&  saisonData.pointAbs!='') { 
                            points = parseInt(saisonData.pointAbs);
                        }
                        var tournoiClassement = {
                            rang: null,
                            date: tournoiItem.date,
                            nbPartieGagne: 0,
                            nbPartiePerdu: 0,
                            nbPartieEgalite: 0,
                            present: false,
                            points: points,
                            diff: 0,
                            calcul: false
                        }
                        tournoisJoueurs.push(tournoiClassement);
                    }
                }
                
            }
            // on garde que ce qu'il nous interresse
            if (saisonData.mode == 0)
                tournoisJoueurs.sort((a,b)=> {
                    return b.points - a.points || b.diff - a.diff;
                });
            if (saisonData.mode == 1)
                tournoisJoueurs.sort((a,b)=> {
                    return a.points - b.points || b.diff - a.diff;
                });
            
            var tailleConcours = tournoisJoueurs.length;
            if (saisonData.tolerance!=0 && saisonData.tolerance < tournoisJoueurs.length) {
                tailleConcours = saisonData.tolerance;
            }
            for (var indexTournoi=0; indexTournoi < tailleConcours;indexTournoi++)
                tournoisJoueurs[indexTournoi].calcul = true;
            
            if (typeof(joueurItem.userId)=="undefined") {
                joueurItem.userId = null;
            }
            var joueurClasse = {
                nom: joueurItem.nom,
                id: joueurItem.id,
                prenom: joueurItem.prenom,
                pseudo: joueurItem.pseudo,
                userId: joueurItem.userId,
                points : 0,
                pointsReel: 0,
                diff: 0,
                nbPartieGagne: 0,
                nbPartiePerdu: 0,
                nbPartieEgalite: 0,
                nbTournois: 0,
                nbTournoisAbs: 0,
                tournois: tournoisJoueurs,
                nbTournoisTotal: 0
            }
            joueursClassements.push(joueurClasse);
        }
       

        // Peut être faire un petit sort by
        
        // Une fois qu'on a fait ça on calcule le cumul des points du joueurs
        
        joueursClassements.forEach(joueurItemClassement=>{
            var mesTournois = JSON.parse(JSON.stringify(joueurItemClassement.tournois));
           
            for (var index in mesTournois) {
                var joueurTournoiItem = mesTournois[index];
                joueurItemClassement.pointsReel += parseInt(joueurTournoiItem.points);

                if (joueurTournoiItem.present)
                    joueurItemClassement.nbTournoisTotal += 1;
                else
                    joueurItemClassement.nbTournoisAbs += 1;
                if (mesTournois[index].calcul) {
                    joueurItemClassement.points += parseInt(joueurTournoiItem.points);
                    joueurItemClassement.nbPartieGagne += parseInt(joueurTournoiItem.nbPartieGagne);
                    joueurItemClassement.nbPartiePerdu += parseInt(joueurTournoiItem.nbPartiePerdu);
                    joueurItemClassement.nbPartieEgalite += parseInt(joueurTournoiItem.nbPartieEgalite);
                    if (joueurTournoiItem.present)
                        joueurItemClassement.nbTournois += 1;
                    else
                        joueurItemClassement.nbTournoisAbs += 1;
                    
                    joueurItemClassement.diff += joueurTournoiItem.diff;
                }
                joueurItemClassement.tournois.sort((a,b)=> {
                    return a.date - b.date ;
                });
            }
        })


        if (saisonData.mode == 0)
        joueursClassements.sort((a,b)=> {
            return b.points - a.points || b.diff - a.diff;
        });
        if (saisonData.mode == 1)
        joueursClassements.sort((a,b)=> {
            return a.points - b.points || b.diff - a.diff;
        });
        fct(joueursClassements);
    }
    
}


export default {
	object: object
}